module.exports = __webpack_public_path__ + "img/icon3.feb42632.png";